import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_SilentFeatures = () => {
  const [data, setData] = useState(null);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    const apiPath = getAPIPath(currentDomain)?.silentFeatures;
    fetchData(apiPath, setData);
  }, [currentDomain]);

 

  // Function to render rich text content
  const renderRichText = (content) => {
    if (!content || !Array.isArray(content)) return null;

    return content.map((block, blockIndex) => {
      if (block.type === "paragraph") {
        return (
          <p key={blockIndex} className="mb-3">
            {block.children?.map((child, childIndex) => {
              if (child.type === "text") {
                let text = child.text;
                
                // Apply formatting
                if (child.bold) {
                  text = <strong key={childIndex}>{text}</strong>;
                }
                if (child.italic) {
                  text = <em key={childIndex}>{text}</em>;
                }
                if (child.underline) {
                  text = <u key={childIndex}>{text}</u>;
                }
                
                return text;
              }
              return child.text || "";
            })}
          </p>
        );
      } else if (block.type === "list") {
        const ListTag = block.format === "ordered" ? "ol" : "ul";
        
        return (
          <ListTag key={blockIndex} className="feature-list mb-4">
            {block.children?.map((listItem, itemIndex) => {
              if (listItem.type === "list-item") {
                return (
                  <li key={itemIndex} className="feature-item mb-2">
                    {listItem.children?.map((child, childIndex) => {
                      if (child.type === "text") {
                        let text = child.text;
                        
                        // Apply formatting
                        if (child.bold) {
                          text = <strong key={childIndex}>{text}</strong>;
                        }
                        if (child.italic) {
                          text = <em key={childIndex}>{text}</em>;
                        }
                        if (child.underline) {
                          text = <u key={childIndex}>{text}</u>;
                        }
                        
                        return text;
                      }
                      return child.text || "";
                    })}
                  </li>
                );
              }
              return null;
            })}
          </ListTag>
        );
      } else if (block.type === "heading") {
        const HeadingTag = `h${block.level || 3}`;
        return (
          <HeadingTag key={blockIndex} className="mb-3">
            {block.children?.map((child, childIndex) => {
              if (child.type === "text") {
                return child.text;
              }
              return "";
            })}
          </HeadingTag>
        );
      }
      
      return null;
    });
  };

  const silentFeaturesData = data?.data?.attributes;

  return (
    <React.Fragment>
      <Helmet>
        <title>Silent Features | OTPRI | JNTU Anantapur</title>
        <meta
          name="description"
          content="Salient Features of Oil Technological & Pharmaceutical Research Institute, JNTUA"
        />
        <meta
          name="keywords"
          content="Silent Features, OTPRI, Oil Technological, Pharmaceutical Research Institute, JNTUA, Features"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .feature-list {
                        padding-left: 0;
                        list-style: none;
                    }
                    
                    .feature-item {
                        position: relative;
                        padding-left: 30px;
                        padding: 12px 0 12px 30px;
                        margin-bottom: 8px;
                        border-left: 4px solid transparent;
                        border-radius: 4px;
                        transition: all 0.3s ease;
                        background: #f8f9fa;
                    }
                    
                    .feature-item:nth-child(3n+1) {
                        border-left-color: #007bff;
                        background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
                    }
                    
                    .feature-item:nth-child(3n+2) {
                        border-left-color: #28a745;
                        background: linear-gradient(135deg, #f8f9fa 0%, #e8f5e8 100%);
                    }
                    
                    .feature-item:nth-child(3n+3) {
                        border-left-color: #ffc107;
                        background: linear-gradient(135deg, #f8f9fa 0%, #fff8e1 100%);
                    }
                    
                    .feature-item:hover {
                        transform: translateX(5px);
                        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                    }
                    
                    .feature-item::before {
                        content: '•';
                        position: absolute;
                        left: 12px;
                        color: inherit;
                        font-size: 18px;
                        line-height: 1;
                        top: 50%;
                        transform: translateY(-50%);
                    }

                    .feature-item:nth-child(3n+1)::before {
                        color: #007bff;
                    }
                    
                    .feature-item:nth-child(3n+2)::before {
                        color: #28a745;
                    }
                    
                    .feature-item:nth-child(3n+3)::before {
                        color: #ffc107;
                    }

                    .content-section {
                        background: #fff;
                        padding: 30px;
                        border-radius: 10px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                        margin-bottom: 30px;
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Silent Features"
          pageName="Silent Features"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title">
                      {silentFeaturesData?.title || "Salient Features of Institutions"}
                    </h3>
                    
                    <div className="content-section">
                      {silentFeaturesData?.features?.map((feature, index) => (
                        <div key={feature.id || index} className="feature-section mb-4">
                          {renderRichText(feature.content)}
                        </div>
                      ))}
                      
                      {(!silentFeaturesData?.features || silentFeaturesData?.features?.length === 0) && (
                        <div className="text-center" style={{ padding: "60px 20px", color: "#666" }}>
                          <i className="fas fa-list-ul" style={{ fontSize: "48px", marginBottom: "20px", color: "#ddd" }}></i>
                          <br />
                          <h5 style={{ color: "#999", fontWeight: "normal" }}>No features available at the moment.</h5>
                          <p style={{ color: "#bbb", fontSize: "14px" }}>Please check back later for updates.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default OTPRI_SilentFeatures;
